export default function presistedStateStorage(storage){
  return {
    getItem: (key) => key==storage.key ? storage.get() : '',
    setItem: (key, value) => key==storage.key ? storage.set(value) : '',
    removeItem: (key) => key==storage.key ? storage.remove() : ''
  }
}